<script>
  export let menuItems
  export let position = 'belowRight'

  let showMoreMenu = false
  let moreButtonElement

  const closeMoreMenu = function () {
    if (showMoreMenu) {
      showMoreMenu = false
    }
  }

  const hideOnClickOutside = function () {
    const outsideClickListener = function (event) {
      if (moreButtonElement && !moreButtonElement.contains(event.target)) {
        closeMoreMenu()
        document.removeEventListener('click', outsideClickListener)
      }
    }

    document.addEventListener('click', outsideClickListener)
  }

  const toggleMoreMenu = function () {
    if (showMoreMenu) {
      showMoreMenu = false
    } else {
      showMoreMenu = true
      hideOnClickOutside()
    }
  }
</script>

<div class="moreButton" bind:this={moreButtonElement}>
  <button class="iconButton" on:click={toggleMoreMenu}>
    <svg class="icon" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z">
      </path>
    </svg>
  </button>
  {#if showMoreMenu}
    <ul class="moreMenu {position}" on:click={closeMoreMenu}>
      {#each menuItems as item}
        <li>
          {#if item.type === 'button'}
            <button on:click="{() => item.func()}">
              {item.text}
            </button>
          {:else if item.type === 'link'}
            <a class="greyLink" href="{item.href}">
              {item.text}
            </a>
          {/if}
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .moreButton {
    position: relative;

    display: flex;
  }
  ul.moreMenu {
    position: absolute;
    z-index: 10;

    display: flex;
    flex-direction: column;

    list-style: none;

    min-width: max-content;
    padding: 0;
    margin: 0;

    background-color: white;
    border: 1px solid var(--border-color);
    box-shadow: 0px 0px 5px #0004;
  }
  ul.moreMenu.aboveLeft {
    bottom: 100%;
    right: 0;
  }
  ul.moreMenu.aboveRight {
    bottom: 100%;
    left: 0;
  }
  ul.moreMenu.belowLeft {
    top: 100%;
    right: 0;
  }
  ul.moreMenu.belowRight {
    top: 100%;
    left: 0;
  }
  ul.moreMenu li {
    padding: 0;
  }
  ul.moreMenu li > * {
    display: block;

    width: 100%;
    padding: 15px 20px;

    /* This shouldn't be necessary as the `ul` has `min-width: max-content`,
       but wrapping still occurs on iOS Chrome without it. */
    white-space: nowrap;
  }
  ul.moreMenu li:first-child > * {
    padding-top: 20px;
  }
  ul.moreMenu li:last-child > * {
    padding-bottom: 20px;
  }
  ul.moreMenu li > button {
    border: none;
    border-radius: 0;

    background-color: unset;
    text-align: left;
  }
  ul.moreMenu li button:hover,
  ul.moreMenu li button:active {
    background-color: unset;
  }
</style>